import { render, staticRenderFns } from "./IconSales.vue?vue&type=template&id=b6a91aba"
import script from "./IconSales.vue?vue&type=script&lang=js"
export * from "./IconSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports